import useAuth from '../../hooks/utils/useAuth';
import { Spinner } from '../../components/common/spinner';

export const LoginPage = (): JSX.Element => {
  const { keycloak, redirectTo } = useAuth();

  keycloak?.login({
    redirectUri: `${window.location.origin}${redirectTo}`,
  });
  return <Spinner />;
};
